import { render, staticRenderFns } from "./FolderOfferCreateAndEditDialog.vue?vue&type=template&id=53e56de8&scoped=true"
import script from "./FolderOfferCreateAndEditDialog.vue?vue&type=script&lang=js"
export * from "./FolderOfferCreateAndEditDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderOfferCreateAndEditDialog.vue?vue&type=style&index=0&id=53e56de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e56de8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
